<template>
  <div>
    <div :id="id + 'modalPedidos'" class="modal-pdv show modal-full" v-if="modal" tabindex="-1">
      <div class="modal-pdv-content">
        <div class="container-fluid px-1">
          <div class="row no-gutters">
            <div class="col-md-5 col-lg-4 p-1 d-md-block" v-show="!openPedido">
              <div class="border rounded-sm container-pedido p-0">
                <div class="d-md-none py-5 px-2" v-show="load">
                  <loading/>
                </div>
                <div v-if="pedidos.length">
                  <h6 class="mb-0 py-2 text-center border-bottom bg-dark text-white small">Selecione um pedido</h6>
                  <div v-for="p in pedidos" :class="selPedido === p.id_pedido ? 'bg-light' : ''" class="d-flex justify-content-between align-items-center border-bottom pointer">
                    <a href="javascript:" class="d-block w-100 font-weight-bold text-dark text-decoration-none px-2 py-3" @click="selecionarPedido(p)">
                      Pedido: P{{p.id_contador}}
                      <span v-if="p.status === '4'" class="badge bg-danger text-white ml-1">Cancelado</span>
                      <span v-else-if="p.pedido_lecard" class="badge bg-secondary text-white ml-1">Importado</span>
                      <div class="small">{{p.dt_pedido | fDate}}</div>
                    </a>
                    <div v-if="comanda && comanda.status === '1' && p.status !== '4'" class="text-nowrap pr-2">
                      <button v-if="p.tipo_comanda !== '2'" class="btn btn-secondary btn-sm" style="width: 40px" title="Cancelar Pedido" @click="cancelarPedido(p)">
                        <i class="fa fa-trash-alt"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-7 col-lg-8 p-1 d-md-block" v-show="openPedido">
              <div class="border rounded-sm container-pedido">
                <loading v-if="load"/>
                <div v-else-if="pedido">
                  <div v-if="comanda && comanda.status === '1'" class="text-right mb-3 mb-md-2">
                    <button class="btn btn-primary btn-sm mr-1" title="Editar Pedido" @click="editarPedido(pedido)">
                      <i class="fa fa-edit mr-1"></i> Editar
                    </button>
                    <button v-if="!pedido.pedido_lecard" class="btn btn-outline-secondary btn-sm" title="Transferir Pedido" @click="openTransferir()">
                      <i class="fa fa-share-alt mr-1"></i> Transferir
                    </button>
                  </div>
                  <cupom-pedido :pedido="pedido" :id="'cupomListaPedidos'" :show="true"/>
                </div>
                <div class="text-center pt-5" v-else>
                  <div class="mt-4" v-if="!pedidos.length">Esta venda ainda não possui pedidos!</div>
                  <div v-else-if="selPedido" class="mt-4">Nenhum item neste pedido</div>
                  <div v-else class="mt-4">Selecione um pedido</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-content-footer bg-light border-top py-2">
          <div class="container-fluid px-2 px-md-3">
            <div class="row">
              <div class="col-6 col-md-5 col-lg-4 d-flex justify-content-between">
                <button class="btn btn-dark p-3" @click="voltar">
                  <i class="fa fa-chevron-left mr-2"></i>
                  <span>Voltar</span>
                </button>
              </div>
              <div class="col-6 col-md-7 col-lg-8 d-flex" v-if="pedido">
                <div class="ml-auto">
                  <button class="btn btn-third p-3 d-md-inline-block" @click="prepararImpressao()">
                    <i class="fa fa-print mr-2"></i>
                    <span>Imprimir</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="!usaNovaImpressao" :class="{'show': modalImpressao}" class="modal-pdv modal-small">
      <div class="modal-pdv-content">
        <div v-if="pedido" class="container-fluid mb-4">
          <h6 class="font-weight-bold text-center border-bottom pb-3 mb-0">Qual local você quer imprimir?</h6>
          <div v-for="c in impressoras" class="my-3">
            <label class="mb-0 d-block mb-3">
              <input v-model="cozinhas" :value="c" class="mr-1" type="checkbox">
              {{ c.nome_cozinha }}
            </label>
          </div>
        </div>
        <div class="modal-content-footer bg-light border-top p-2 d-flex justify-content-between">
          <button type="button" class="btn btn-outline-dark p-3" @click="modalImpressao = false">
            Fechar
          </button>
          <button :disabled="!cozinhas.length" class="btn btn-success p-3" @click="imprimir()">
            Imprimir
          </button>
        </div>
      </div>
    </div>

    <modal-reimpressao-delivery
      v-if="usaNovaImpressao"
      :loading="loadRegrasImpressao"
      :opened="modalImpressao"
      :regras="regrasImpressao"
      @close="fecharModalImpressao()"
      @confirm="confirmarReimpressao($event)"
    />

    <div class="modal-pdv modal-small" :class="{'show': modalTransferir}">
      <div class="modal-pdv-content">
        <form @submit.prevent="transferirPedido">
          <div class="container-fluid mb-4">
            <h6 class="font-weight-bold text-center">Qual local você deseja transferir?</h6>
            <hr>
            <div class="form-group mb-2">
              <label class="mb-0 small font-weight-bold">Tipo da Venda</label>
              <select class="form-control" v-model="transferir.tipo_comanda" required>
                <option value="3">Comanda</option>
                <option value="1">Mesa</option>
              </select>
            </div>
            <div class="form-group mb-2" v-if="transferir.tipo_comanda === '1'">
              <label class="mb-0 small font-weight-bold">Mesa:</label>
              <input type="number" class="form-control" v-model="transferir.mesa" placeholder="Nº da mesa" required/>
            </div>
            <div class="form-group mb-2" v-if="transferir.tipo_comanda === '3'">
              <label class="mb-0 small font-weight-bold">Comanda</label>
              <input type="number" class="form-control" placeholder="Ex: 123" v-model="transferir.ref_comanda" required/>
            </div>
          </div>
          <div class="modal-content-footer bg-light border-top p-2 d-flex justify-content-between">
            <button type="button" class="btn btn-outline-dark p-3" @click="modalTransferir = null">
              Fechar
            </button>
            <button class="btn btn-success p-3">
              Transferir
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
  import Loading from "../../../components/commons/Loading";
  import CupomPedido from "./CupomPedido";
  import ModalReimpressaoDelivery from "@/components/gestor/ModalReimpressaoDelivery";

  export default {
    name: "ListaPedidos",
    components: {CupomPedido, Loading, ModalReimpressaoDelivery},
    props: ['comanda'],
    data() {
      return {
        modal: false,
        id: this.$helpers.ID(),
        load: true,
        token: localStorage.getItem('key'),
        empresa: localStorage.getItem('token'),
        pedidos: [],
        cachePedidos: [],
        pedido: null,
        total: 0.00,
        openPedido: false,
        selPedido: false,
        cozinhas: [],
        impressoras: [],
        modalImpressao: false,
        loadRegrasImpressao: false,
        regrasImpressao: [],
        id_comanda: null,
        modalTransferir: null,
        transferir: {
          id_pedido: '',
          tipo_comanda: '1',
          mesa: '',
          ref_comanda: ''
        }
      }
    },

    methods: {
      toggleModal(m, callback) {
        this.modal = m;
        this.$nextTick(() => {
          this.$helpers.toggleModal(m, this.id + 'modalPedidos', this.toggleModal);

          if (m) {
            this.$helpers.focusElement(this.input);
          }

          if (callback) {
            callback();
          }
        });
      },

      openListPedidos(id_comanda) {
        if (id_comanda) {
          this.pedidos = [];
          this.cozinhas = [];
          this.pedido = null;
          this.selPedido = null;
          this.openPedido = false;
          this.id_comanda = id_comanda;
          this.getPedidos();
          this.toggleModal(true);
        }
      },

      editarPedidoDelivery(id_comanda) {
        if (id_comanda) {
          this.pedidos = [];
          this.cozinhas = [];
          this.pedido = null;
          this.openPedido = false;
          this.id_comanda = id_comanda;
          this.toggleModal(true);

          this.getPedidos(() => {
            this.getPedido(this.pedidos[0].id_pedido, true);
          });
        }
      },

      getPedidos(callback, full) {
        this.cachePedidos = [];
        this.load = true;
        this.$http.get('pdv/pedidos/' + this.token, { params: { comanda: this.id_comanda, full }})
          .then(response => {
            this.load = false;
            this.pedidos = response.data || [];

            if (!this.pedidos.length) {
              return;
            }

            if (callback) {
              callback();
              return;
            }

            if (this.pedidos.length === 1) {
              this.selecionarPedido(this.pedidos[0]);
            }

          }, res => {
            this.load = false;
            this.$swal(res.data.msg && res.data.msg ? res.data.msg : 'Erro Temporário');
          });
      },

      getPedido(id_pedido, editar) {
        this.load = true;
        this.$http.get('pdv/pedido/' + this.token + '?id_pedido=' + id_pedido)
          .then(response => {
            this.load = false;

            if (response.data?.id_pedido) {
              this.pedido = response.data;
              this.cachePedidos.push(this.pedido);

              if (editar) {
                this.editarPedido(this.pedido, true);
              }
            }

          }, res => {
            this.load = false;
            this.$swal(res.data?.msg || 'Erro Temporário');
          });
      },

      selecionarPedido(p) {
        if (!p || this.load) return;

        this.cozinhas = [];
        this.openPedido = this.is_mobile;
        this.selPedido = p.id_pedido;
        this.pedido = null;
        const pedido = this.cachePedidos.find(pedido => pedido.id_pedido === this.selPedido);

        if (pedido) {
          this.pedido = pedido;

        } else {
          this.getPedido(this.selPedido);
        }
      },

      prepararImpressao() {
        if (this.usaNovaImpressao) {
          this.modalImpressao = true;

          this.carregarRegrasImpressao(this.pedido, (regras, error) => {
            if (error) {
              this.$swal(error);
              return;
            }

            this.regrasImpressao = regras;
          });
          return;
        }

        const cozinhas = this.pedido.cozinhas || [];
        const deviceDefault = this.impressora.device;
        const devicePdv = this.impressora.devicePdv;
        const impressorasBase = [ { id_cozinha: null, nome_cozinha: 'Impressora pedidos (Padrão)', device: deviceDefault }];

        if (deviceDefault !== devicePdv) {
          impressorasBase.push({ id_cozinha: null, nome_cozinha: 'Impressora comprovante', device: devicePdv });
        }

        this.impressoras = [ ...impressorasBase, ...cozinhas ]

        if (!this.impressora.mobilePrint && this.impressoras.length > 1) {
          this.cozinhas = [impressorasBase[0]];
          this.modalImpressao = true;

        } else {
          this.imprimir();
        }
      },

      imprimir() {
        this.modalImpressao = false;

        if (this.pedido.tipo_pedido !== '3') {
          this.cozinhas = this.cozinhas.map(c => { return { ...c, id_cozinha: null } });
        }

        this.$helpers.imprimirPedido(this, this.pedido.id_pedido, this.empresa, 'cupomListaPedidos', this.cozinhas, false, () => {
          if (this.isElectron) {
            this.$swal('Impressão enviada com sucesso!');
          }
        });
      },

      carregarRegrasImpressao(pedido, callback) {
        if (!pedido || !pedido.id_pedido) {
          callback([], 'Pedido inválido');
          return;
        }

        this.loadRegrasImpressao = true;

        this.$http.get(`v2/impressao/pdv-pedido/${pedido.id_pedido}/regras`)
          .then((res) => {
            this.loadRegrasImpressao = false;
            callback(res.data || []);

          }, (res) => {
            this.loadRegrasImpressao = false;
            callback([], (res.data || {}).erro || (res.data || {}).msg || 'Não foi possível obter as regras de impressão.');
          });
      },

      confirmarReimpressao(options) {
        this.fecharModalImpressao();
        this.solicitarImpressaoPedido(this.pedido, options);
      },

      fecharModalImpressao() {
        this.modalImpressao = false;
        this.regrasImpressao = [];
      },

      solicitarImpressaoPedido(pedido, options = {}) {
        if (!pedido || !pedido.id_pedido) {
          return;
        }

        const { regras = null, destino = null, qtd_copias = 1 } = options;
        const payload = { id_pedido: pedido.id_pedido };

        if (destino) {
          payload.destino = destino;
          payload.qtd_copias = qtd_copias;
        } else if (regras && regras.length) {
          payload.regras = regras;
          payload.qtd_copias = qtd_copias;
        }

        this.$store.state.load = true;
        this.$http.post('v2/impressao/pdv-pedido', payload)
          .then((res) => {
            this.$store.state.load = false;
            const data = res.data || {};

            if (!data.success || !data.id_impressao) {
              this.$swal(data.msg || 'Não foi possível enviar o pedido para a fila de impressão.');
              return;
            }

            const ids = data.ids_impressao && data.ids_impressao.length ? data.ids_impressao : [data.id_impressao];
            if (!this.printServer) this.$store.commit('acompanharImpressaoRemota', ids);
          }, (res) => {
            console.log(res);
            this.$store.state.load = false;
            this.$swal((res.data || {}).msg || 'Não foi possível enviar o pedido para a fila de impressão.');
          });
      },

      editarPedido(pedido, direto) {
        if (pedido.pedido_lecard) {
          this.$swal("Este pedido foi importado. Acesse o gestor para alterar.");
          return;
        }

        if (!direto) {
          this.$swal({
            text: 'Deseja editar este pedido?',
            buttons: ['Não', 'Sim'],
            dangerMode: true
          }).then((result) => {
            if (result) {
              this.$helpers.confirmarSenhaAdm(this, () => {
                this.toggleModal(false, () => {
                  this.$emit('editarPedido', { ...pedido, comanda: this.comanda });
                });
              });
            }
          });

        } else {
          this.$helpers.confirmarSenhaAdm(this, () => {
            this.toggleModal(false, () => {
              this.$emit('editarPedido', { ...pedido, comanda: this.comanda });
            });
          });
        }
      },

      cancelarPedido(p) {
        this.$helpers.confirmarSenhaAdm(this, this.removerPedido, p);
      },

      removerPedido(p) {
        this.$swal({
          text: 'Atenção, esta opção é irreversível, todos os itens deste pedido serão removidos da venda atual.\n\nDeseja realmente cancelar este pedido?',
          buttons: ['Não', 'Sim, cancelar!'],
          dangerMode: true
        }).then((result) => {
          if (result) {
            this.$store.state.load = true;
            this.$http.post("pdv/pedido/remover/" + this.token, { id_pedido: p.id_pedido }).then(res => {
              this.$store.state.load = false;
              this.pedido = null;
              this.getPedidos();
              this.$emit('atualizarVenda');

            }, res => {
              this.$store.state.load = false;
              this.$swal(res.data.msg && res.data.msg ? res.data.msg : 'Erro Temporário');
            });
          }
        });
      },

      openTransferir() {
        if (this.pedido.pedido_lecard) {
          this.$swal("Este pedido foi importado. Acesse o gestor para alterar.");
          return;
        }

        this.modalTransferir = true;
        this.transferir.id_pedido = this.pedido.id_pedido;
        this.transferir.tipo_comanda = '3';
        this.transferir.ref_comanda = '';
        this.transferir.mesa = '';
      },

      transferirPedido() {
        this.$helpers.confirmarSenhaAdm(this, () => {
          this.$swal({
            text: 'Atenção, os itens deste pedido serão movidas para a venda informada.\n\nDeseja realmente transferir este pedido?',
            buttons: ['Não', 'Sim, transferir!'],
            dangerMode: true
          }).then((result) => {
            if (result) {
              this.$store.state.load = true;
              this.$http.post("pdv/pedido/transferir/" + this.token, this.transferir).then(res => {
                this.$store.state.load = false;

                if (res.data && res.data.id_comanda) {
                  this.pedido = null;
                  this.modalTransferir = null;
                  this.$router.push('/pdv/' + res.data.id_comanda);
                  this.toggleModal(false);
                  this.$swal('Pedido transferido com sucesso!');

                } else {
                  this.$swal('Erro ao transferir esta venda');
                }

              }, res => {
                this.$store.state.load = false;
                this.$swal(res.data.msg && res.data.msg ? res.data.msg : 'Erro Temporário');
              });
            }
          });
        });
      },

      voltar() {
        if (this.openPedido) {
          this.openPedido = false;
          this.pedido = null;

        } else {
          this.toggleModal(false);
        }
      }
    },

    computed: {
      usuario() {
        return this.$store.state.dataUser
      },

      impressora() {
        return this.$store.state.impressora
      },

      configImpressao() {
        return this.$store.state.configImpressao;
      },

      usaNovaImpressao() {
        return Number(this.configImpressao.migrado_legado || 0) === 1;
      },

      printServer() {
        return this.$store.state.printServer;
      }
    }
  }
</script>

<style scoped>
  .container-pedido {
    height: calc(100vh - 166px);
    overflow-y: auto;
    overflow-x: hidden;
    padding: 15px 15px 26px;
  }

  @media (max-width: 991px) {
    .container-pedido {
      height: auto!important;
      overflow: visible;
      min-height: calc(100vh - 112px);
    }
  }
</style>
